<template>
  <header class="m-header">
    <div class="m-header-bg" :style="style">
      <div class="m-header-title fz15">{{title}}</div>
    </div>
  </header>
</template>

<script>
export default {
  computed: {
    style () {
      const pdb = 100 * this.$store.state.header.ratio
      const bgurl = this.bgsrc
      const s = `padding-bottom: ${pdb}%;background-image: url(${bgurl});`
      return s
    },
    bgsrc () {
      return this.$store.state.header.pageInfo.HeaderImageUrl
    },
    title () {
      return this.$store.state.header.pageInfo.Title
    }
  }
}
</script>



// WEBPACK FOOTER //
// header.vue?0987306e